import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M13.5 8.5L10.5 12L13.5 15.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
